module.exports = __webpack_public_path__ + "static/media/riotinto.f76a59ac.png";